import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";

function PilotProfile({ onClose }) {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");

    const [displayName, setDisplayName] = useState("");
    const [fullName, setFullName] = useState("");

    const [ifrCeiling, setIfrCeiling] = useState(500);

    const [ifrVisibility, setIfrVisibility] = useState(1.0);

    const [crosswindMax, setCrosswindMax] = useState(20);

    const [tailwindMax, setTailwindMax] = useState(10);

    const [alternateCeiling, setAlternateCeiling] = useState(2000);

    const [alternateVisibility, setAlternateVisibility] = useState(5.0);

    const [preferredRunwayLength, setPreferredRunwayLength] = useState(5000);

    const [homeAirport, setHomeAirport] = useState("");
    const [defaultAircraft, setDefaultAircraft] = useState("");

    useEffect(() => {
        loadProfile();
    }, []);

    async function loadProfile() {
        try {
            const token = localStorage.getItem("token");

            const response = await fetch("https://ficon-x.com/auth/me", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Unable to load profile");
            }

            setUsername(data.username || "");
            setEmail(data.email || "");
            setDisplayName(data.display_name || "");
            setFullName(data.full_name || "");
            setHomeAirport(data.home_airport || "");
            setDefaultAircraft(data.default_aircraft || "");
            setIfrCeiling(data.ifr_ceiling_min_ft ?? 500);

            setIfrVisibility(data.ifr_visibility_min_sm ?? 1.0);

            setCrosswindMax(data.crosswind_max_kt ?? 20);

            setTailwindMax(data.tailwind_max_kt ?? 10);

            setAlternateCeiling(data.alternate_ceiling_min_ft ?? 2000);

            setAlternateVisibility(data.alternate_visibility_min_sm ?? 5.0);

            setPreferredRunwayLength(data.preferred_runway_length_ft ?? 5000);
        } catch (err) {
            console.error(err);
            alert("Failed to load profile.");
        } finally {
            setLoading(false);
        }
    }

    async function saveProfile() {
        try {
            setSaving(true);

            const token = localStorage.getItem("token");

            const response = await fetch(
                "https://ficon-x.com/auth/update-profile",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        display_name: displayName,
                        full_name: fullName,
                        home_airport: homeAirport,
                        default_aircraft: defaultAircraft,
                        ifr_ceiling_min_ft: ifrCeiling,

                        ifr_visibility_min_sm: ifrVisibility,

                        crosswind_max_kt: crosswindMax,

                        tailwind_max_kt: tailwindMax,

                        alternate_ceiling_min_ft: alternateCeiling,

                        alternate_visibility_min_sm: alternateVisibility,

                        preferred_runway_length_ft: preferredRunwayLength,
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Save failed");
            }

            alert("Profile updated successfully.");

            if (onClose) {
                onClose();
            }
        } catch (err) {
            console.error(err);
            alert("Unable to save profile.");
        } finally {
            setSaving(false);
        }
    }

    if (loading) {
        return (
            <div style={{ padding: "20px" }}>
                Loading Profile...
            </div>
        );
    }

return ReactDOM.createPortal(

<div
    style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999999
    }}
>

    <div
        style={{
            width: "500px",
            maxWidth: "95%",
            background: "#fff",
            borderRadius: "10px",
            padding: "25px",
            boxShadow: "0 10px 40px rgba(0,0,0,.35)"
        }}
    >
        <h2 style={{ marginTop: 0 }}>
            Pilot Profile
        </h2>

        <p
            style={{
                color: "#666",
                fontSize: "14px",
                marginTop: "-5px",
                marginBottom: "20px",
                lineHeight: "1.4"
            }}
        >
            Manage your account information and default flight planning preferences.
        </p>

        <hr />

        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Username
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Used to sign in to FICON-X.
            </div>

            <input
                type="text"
                value={username}
                readOnly
                style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px"
                }}
            />
        </div>

        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Email Address
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Used for login and account recovery.
            </div>

            <input
                type="text"
                value={email}
                readOnly
                style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px"
                }}
            />
        </div>

        <hr />

        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Public Display Name
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Name visible to other FICON-X users.
            </div>

            <input
                type="text"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px"
                }}
            />
        </div>

        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Full Legal Name
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Used for future FAA flight filing.
            </div>

            <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px"
                }}
            />
        </div>

        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Home Airport
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Default departure airport.
            </div>

            <input
                type="text"
                value={homeAirport}
                onChange={(e) => setHomeAirport(e.target.value.toUpperCase())}
                placeholder="KORD"
                style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px"
                }}
            />
        </div>

        <div style={{ marginBottom: "20px" }}>
            <label style={{ fontWeight: "600" }}>
                Default Aircraft Type
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                ICAO aircraft type (B738, A320, C172).
            </div>

            <input
                type="text"
                value={defaultAircraft}
                onChange={(e) => setDefaultAircraft(e.target.value.toUpperCase())}
                placeholder="B738"
                style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px"
                }}
            />
        </div>

        <div
            style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "25px"
            }}
        >
            <button
                onClick={() => {
                    if (onClose) {
                        onClose();
                    }
                }}
            >
                Cancel
            </button>

            <button
                onClick={saveProfile}
                disabled={saving}
            >
                {saving ? "Saving..." : "Save Changes"}
            </button>
        </div>
        </div>

    </div>,

    document.body

);
}

export default PilotProfile;